import request from "../../Requests/requests";
import { getTagsToTask } from "../../asyncActions/TagsToTaskActions/getTagsToTask";

export const addTagsToTask = (payload) => {
    return async dispatch => {
        try {
            const response = await request.post('/Task/AddTag', {
                taskId: payload.taskId,
                tagId: payload.tagId
            })
            const data = response.data
            dispatch(getTagsToTask(payload))
            return (data)
        } catch (error) {
            return error
        }
    }
}